import { render, staticRenderFns } from "./collectSix.vue?vue&type=template&id=b3832a72&scoped=true"
import script from "./collectSix.vue?vue&type=script&lang=js"
export * from "./collectSix.vue?vue&type=script&lang=js"
import style0 from "./collectSix.vue?vue&type=style&index=0&id=b3832a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3832a72",
  null
  
)

export default component.exports